import { useState } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useGlobalContext } from "../Config";
import { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import ClienteDetalleModal from './ClienteDetalleModal';


const FormCrearDocumento = ({
    isFormVisible,
    setIsFormVisible,
    empresa,
    setEmpresa,
    idContrato,
    setIdContrato,
    idEmpresa,
    setIdEmpresa,
    idCliente,
    setIdCliente,
    razonSocial,
    setRazonSocial,
    idCotizacion,
    setIdCotizacion,
    fetchDocumentos,
    toast,
}) => {
    const [loading, setLoading] = useState(false);
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [tiposDocumentoOptions, setTiposDocumentoOptions] = useState([]);
    const [plantillasDocumentoOptions, setPlantillasDocumentoOptions] = useState([]);
    const [plantillasDocumento, setPlantillasDocumento] = useState([]);
    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);
    const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null);
    const [nombre, setNombre] = useState('');
    const [metadataCargada, setMetadataCargada] = useState(false);

    const { baseUrl, urlContratos } = useGlobalContext();

    useEffect(() => {
        if (isFormVisible && empresa) {
            obtenerTiposDocumentoByEmpresa();
            
        }
        if (tipoSeleccionado) {
            obtenerPlantillasDocumentoByEmpresa(tipoSeleccionado.id);
        }
    }, [isFormVisible, urlContratos, empresa, tipoSeleccionado]);


    const obtenerTiposDocumentoByEmpresa = async () => {
        try {
            const response = await fetch(
                `${urlContratos}getTiposDocumentoByEmpresa?empresa=${empresa}`,
                {
                    method: 'GET',
                    credentials: 'include',
                }
            );
            const data = await response.json();
            const lista = Array.isArray(data.tiposDocumentos) ? data.tiposDocumentos : Object.values(data.tiposDocumentos || {});
            setTiposDocumentoOptions(lista);
        } catch (error) {
            console.error("Error al obtener los tipos de documento:", error);
        }
    };

    const obtenerPlantillasDocumentoByEmpresa = async (idTipoDocumento) => {
        try {
            const response = await fetch(
                `${urlContratos}getPlantillasDocumentoByEmpresa?empresa=${empresa}&idTipo=${idTipoDocumento}`,
                {
                    method: 'GET',
                    credentials: 'include',
                }
            );
            const data = await response.json();
            const lista = Array.isArray(data.plantillasDocumentos) ? data.plantillasDocumentos : Object.values(data.plantillasDocumentos || {});
            setPlantillasDocumentoOptions(lista);
        } catch (error) {
            console.error("Error al obtener las plantillas de documento:", error);
        }
    };

    // Botón Guardar: envía la plantilla al backend
    const handleGuardar = async () => {
        try {
            setLoading(true);  
            if (!empresa || !tipoSeleccionado || !plantillaSeleccionada || !nombre) {
                toast.current?.show({ severity: 'warn', summary: 'Campos requeridos', detail: 'Complete todos los campos requeridos', life: 3000 });
                return;
            }

            if (!idCotizacion) {
                toast.current?.show({ severity: 'warn', summary: 'Cotización requerida', detail: 'No se encontró la cotización para obtener metadata', life: 3500 });
                return;
            }

            const metadataResponse = await fetch(
                `${baseUrl}getMetadataByCotizacionId?idCotizacion=${encodeURIComponent(idCotizacion)}`,
                {
                    method: 'GET',
                    credentials: 'include',
                }
            );

            if (!metadataResponse.ok) {
                throw new Error(`No se pudo obtener metadata de cotización (${metadataResponse.status})`);
            }

            const metadataData = await metadataResponse.json();
            const metadataRaw =
                metadataData?.metadataJson ??
                metadataData?.metadata_json ??
                metadataData?.metadata ??
                metadataData?.data ??
                metadataData ??
                {};

            const metadataJson = typeof metadataRaw === 'string'
                ? JSON.parse(metadataRaw || '{}')
                : (metadataRaw && typeof metadataRaw === 'object' ? metadataRaw : {});

            setMetadataCargada(true);

            const payload = {
                idEmpresa: idEmpresa,
                idPlantilla: plantillaSeleccionada?.id ?? null,
                idContrato: idContrato ?? null,
                idUsuario: Number(sessionStorage.getItem('usuario_id') || 0),
                idTipoDocumento: tipoSeleccionado?.id ?? null,
                idEstadoDocumento: 1,
                filename: nombre || 'documento.docx',
                metadataJson,
            };

            const response = await fetch(`${urlContratos}guardarMetadataDocumento`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                credentials: 'include',
            });

            if (!response.ok) {
                let detail = `El documento ingreso ya existe, porfavor reingrese tipo o plantilla diferente.`;
                try {
                    const errData = await response.json();
                    detail = errData?.message || detail;
                } catch {
                    try {
                        const errText = await response.text();
                        detail = errText || detail;
                    } catch {}
                }

                toast.current?.show({
                    severity: 'error',
                    summary: 'Error al guardar',
                    detail,
                    life: 4000
                });
                return;
            }else{
                await fetchDocumentos();
                toast.current?.show({
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'Documento creado con éxito',
                    life: 3000
                });
            }
        } catch (err) {
            console.error(err);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar el documento', life: 4000 });
        } finally {
            setLoading(false);  
            resetFormDocumento();
            setIsFormVisible(false);
        }
    };

    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [showClienteModal, setShowClienteModal] = useState(false);
    const openClienteModal = async (idCliente) => {
        const response = await fetch(`${baseUrl}getClienteById?idCliente=${idCliente}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
            });
        const data = await response.json();
        setClienteSeleccionado(data);
        setShowClienteModal(true);
    };
    const closeClienteModal = () => {
        setShowClienteModal(false);
        setClienteSeleccionado(null);
    };

    const resetFormDocumento = () => {
        setTipoSeleccionado(null);
        setPlantillaSeleccionada(null);
        setNombre('');
        setEmpresa(null);
        setRazonSocial('');
        setIdCliente(null);
        setIdEmpresa(null);
        setIdContrato(null);
        setIdCotizacion(null);
        setMetadataCargada(false);
    };

    const handleDialogHide = () => {
        resetFormDocumento();
        setIsFormVisible(false);
    };

    return (
        <div>
            <Dialog
                visible={isFormVisible}
                onHide={handleDialogHide}
                className="p-fluid product-dialog"
                closable={handleDialogHide}
                modal
                footer={
                    <div className="flex justify-content-end mt-3">
                        <Button
                            label="Guardar"
                            icon={loading ? "pi pi-spin pi-spinner" : "pi pi-save"}
                            className="p-button-success p-button-rounded"
                            onClick={handleGuardar}
                            disabled={!empresa || !tiposDocumento || !plantillasDocumento || !nombre || loading}
                            raised
                        />
                    </div>
                }
                header="Crear Documento"
            >
                <div className="card">
                    <h6 className="mb-3">
                        Información del Documento
                    </h6>                

                    <h7>
                        Cliente:<Button
                                    className="p-button-link p-0"
                                    label={razonSocial || "Sin razón social"}
                                    onClick={() => openClienteModal(idCliente)}
                                    tooltip="Ver detalles del cliente"
                                    tooltipOptions={{ position: "top" }}
                                    draggable={false}
                                />
                        Empresa Arrendadora: {empresa}

                        {/* N° de contrato: {idContrato} */}
                    </h7>   


                    <div className="grid mt-2 mb-3">
                        <div className="col-12 md:col-4">
                            <span className="p-float-label w-full">
                                <Dropdown
                                    id="tipoDocumento"
                                    value={tipoSeleccionado}
                                    onChange={(e) => setTipoSeleccionado(e.value)}
                                    options={tiposDocumentoOptions}
                                    optionLabel="descripcion"
                                    placeholder="Seleccione un tipo de documento"
                                    className="w-full p-inputtext-lg"
                                    required
                                    disabled = {loading}
                                />
                                <label htmlFor="tipoDocumento">Tipo de Documento</label>
                            </span>
                        </div>

                        <div className="col-12 md:col-4">
                            <span className="p-float-label w-full">
                                <Dropdown
                                    id="plantillaDocumento"
                                    value={plantillaSeleccionada}
                                    onChange={(e) => setPlantillaSeleccionada(e.value)}
                                    options={plantillasDocumentoOptions}
                                    optionLabel="nombre"
                                    placeholder="Seleccione Plantilla"
                                    className="w-full p-inputtext-lg"
                                    required
                                    disabled = {!tipoSeleccionado || loading}
                                />
                                <label htmlFor="plantillaDocumento">Plantilla de Documento</label>
                            </span>
                        </div>

                        <div className="col-12 md:col-4">
                            <span className="p-float-label w-full">
                                <InputText
                                    id="nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    placeholder="Ingrese nombre del archivo"
                                    maxLength={100}
                                    className="w-full p-inputtext-lg"
                                    required
                                    disabled = {loading}
                                />
                                <label htmlFor="nombre">Nombre de Documento</label>
                            </span>
                        </div>
                    </div>

                    <div className="mt-3 p-3 border-round surface-100 text-700">
                        Los datos se obtiene automáticamente desde el servicio al guardar.
                        {metadataCargada ? ' Metadata cargada correctamente en esta sesión.' : ''}
                    </div>

                </div>
            </Dialog>

            <ClienteDetalleModal
                visible={showClienteModal}
                onHide={closeClienteModal}
                cliente={clienteSeleccionado}
            />
        </div>
    );
}
export default FormCrearDocumento;
